import React from 'react';
import { getTrackingData } from '@teko/tracking';
import { MobileProductCard } from '../ProductCard/MobileProductCard.es.js';
import { HorizontalSlider } from '../HorizontalSlider/HorizontalSlider.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MobileProductCarousel = ({
  products,
  productsPerRow,
  regionName,
  hideCtaButton
}) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "wrapper-horizontal-slider"
  }, /* @__PURE__ */ React.createElement(HorizontalSlider, {
    slidesPerView: productsPerRow || 2.3,
    className: "horizontal-slider"
  }, products.map((product, index) => /* @__PURE__ */ React.createElement(MobileProductCard, __spreadProps(__spreadValues({
    key: index
  }, product), {
    tracking: regionName ? getTrackingData({
      regionName,
      isTrackContent: true,
      contentName: product.sku,
      target: "productDetail"
    }) : {},
    addToCart: hideCtaButton ? null : product.addToCart
  })))));
};

export { MobileProductCarousel };
